export const NAME = 'registerReducer';
